<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>

<script>
import { mapState } from 'vuex'
import { isArray, isEmpty, isObject } from 'lodash'

export default {
  name: 'ProfileVariantGuestView',
  components: {
    CooperationRequestOverlay: () => import('@/components/overlays/CooperationRequestOverlay'),
    ProfileTopLeftSection: () => import('@/views/ProfilePage/variants/profileSections/ProfileTopLeftSection'),
  },
  props: {
    topics: Array,
  },
  data() {
    return {
      openOverlay: false,
      avatarStyleClass: '',
    }
  },
  computed: {
    ...mapState('users', [
      'user',
      'userTopics',
      'userCustomFields',
    ]),
    ...mapState('auth', ['settings']),
    userStatus() {
      return this.user.status ? this.user.status.text : ''
    },
    personalDataTitle() {
      return this.isInCustomerProfileOptions('Cards', 'custom-fields') ?
        this.userCustomFields[0] && this.userCustomFields[0].title : this.$t('profile.own_profile.personal_data.title')
    },
  },
  methods: {
    userConversation() {
      this.$emit('userConversation')
    },
    closeOverlay() {
      this.openOverlay = false
    },
    toggleOverlay() {
      this.openOverlay = true
    },
    displayValue(rawValue) {
      const value = isArray(rawValue) ? rawValue[0] : rawValue
      return value ? (
        isObject(value) ? (
          isEmpty(value) ? '' : value.text
        ) : value
      ) : ''
    },
  },
}
</script>
